<template>
  <b-modal
    id="modal-create-activity"
    style="width: min-content; padding: 10px"
    hide-footer
    centered
    @hidden="resetModal"
    :noCloseOnBackdrop="isBusy"
    :noCloseOnEsc="isBusy"
    :hideHeaderClose="isBusy"
  >
    <div>
      <h1 class="title-modal-activity">{{ titleModalActivity }}</h1>
      <div class="mt-5">
        <form @submit.prevent="saveActivity">
          <div class="row">
            <div class="col-12">
              <Input
                label="Nombre de la actividad"
                class="mb-5"
                name="name"
                :value="formData.name"
                @input="(event) => (formData.name = event.target.value)"
              />
            </div>
          </div>
          <div class="row align-content-center justify-content-center">
            <div>
              <button
                :disabled="isBusy || formData.name === ''"
                class="button_primary mr-4"
                @click.prevent="saveActivity()"
              >
                <span>{{
                  record?.id ? "Guardar cambios" : "Guardar Actividad"
                }}</span>
                <b-spinner v-if="isBusy" />
              </button>
            </div>
            <button
              class="button-secundary"
              :disabled="isBusy"
              @click.prevent="$bvModal.hide('modal-create-activity')"
            >
              <span>Cancelar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { createActivity, editActivity } from "@/services/health-tracker/matrizIper/service";
import useInputs from "@/components/general/Inputs";
const { Input } = useInputs();

export default {
  components: {
    Input,
  },
  props: {
    titleModalActivity: {
      type: String,
      default: () => "",
    },
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        name: "",
      },
      isBusy: false,
    };
  },
  watch: {
    record() {
      const me = this;
      if (me.record) {
        me.formData = {
          name: me.record.name,
          id: me.record.id,
        };
        console.log(me.formData);
      }
    },
  },
  methods: {
    async saveActivity() {
      const me = this;
      me.isBusy = true;
      try {
        me.record?.id ? await editActivity(me.formData, me.formData.id) : await createActivity(me.formData);
        me.$bvModal.hide("modal-create-activity");
        me.$bvModal.show("modal-success");
        me.$emit("onSaveActivity");
      } catch (error) {
        me.$bvModal.show("modal-fail");
      } finally {
        me.isBusy = false;
      }
    },
    resetModal() {
      const me = this;
      me.formData = {
        name: "",
      };
    },
  },
};
</script>
<style lang="scss">
.button_primary {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  gap: 10px;
  border: none;
  color: white;
  padding: 15px;
}
.title-modal-activity {
  font-size: 18px;
}
</style>
